import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const DealerVisitList = Loadable(lazy(() => import("./DealerVisitList")));
const DealerVisitForm = Loadable(lazy(() => import("./DealerVisitForm")));

const dealerVisitRoutes = [
  {
    path: "/DealerVisit/DealerVisitList",
    element: <DealerVisitList />,
    permission: PERMISSIONS.DealerVisits.Menu,
  },
  {
    path: "/DealerVisit/DealerVisitForm",
    element: <DealerVisitForm />,
  },
  {
    path: "/DealerVisit/DealerVisitForm/:dealerVisitId",
    element: <DealerVisitForm />,
  },
];
export default dealerVisitRoutes;
